
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33781',
  depVersions: {
  "documents-public-ui": "static-1.33781",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33786",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1838",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5308",
  "hs-test-utils": "static-1.7700",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11141",
  "I18n": "static-7.1548",
  "jasmine-immutable": "static-1.2735",
  "jasmine-runner": "static-1.6173",
  "lodash": "static-1.3",
  "quartz": "static-1.6604",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16351",
  "reporting-data": "static-1.66177",
  "reporting-testing-lib": "static-1.8110",
  "reporting-visualizations": "static-1.58253",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4461",
  "webpack-env": "static-1.54",
  "atom": "static-1.4789",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2183",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.707",
  "customer-data-filters-ui": "static-1.38591",
  "customer-data-objects": "static-1.7332",
  "customer-data-property-utils": "static-1.7786",
  "data-fetching-client": "static-1.9393",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4251",
  "flux-actions": "static-1.299",
  "FormsCommonComponents": "static-1.85069",
  "FormUrlGenerator": "static-2.4448",
  "foundations-components": "static-1.7347",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11449",
  "icons": "static-2.615",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6861",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3577",
  "property-translator": "static-1.5131",
  "quartz-config": "static-1.382",
  "quartz-core": "static-1.5823",
  "quick-fetch": "static-1.3653",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5101",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7879",
  "reference-resolvers-lite": "static-1.7806",
  "report-customization-components": "static-1.12268",
  "reporting-enablement": "static-1.21805",
  "reporting-reports": "static-1.65855",
  "reporting-snowflake": "static-1.54795",
  "reporting-ui-components": "static-2.63449",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4324",
  "sales-content-partitioning": "static-1.8651",
  "SalesContentIndexUI": "static-3.8765",
  "sanitize": "static-1.4192",
  "sanitize-text": "static-1.7857",
  "self-service-api": "static-1.9944",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1464",
  "signup-constants": "static-1.18235",
  "signup-ui-lego-core": "static-1.20245",
  "signup-ui-url-generator": "static-2.7750",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4490",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10713",
  "ui-addon-i18n": "static-1.10845",
  "ui-addon-react-router-dom": "static-1.9264",
  "ui-addon-upgrades": "static-9.17444",
  "ui-asset-management-lib": "static-1.10582",
  "ui-images": "static-2.1068",
  "UIComponents": "static-3.8088",
  "usage-tracker": "static-1.7052",
  "usage-tracker-container": "static-1.7042",
  "usage-tracker-core": "static-1.6902",
  "usage-tracker-public": "static-1.6863",
  "viral-links-lib": "static-1.6739",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3153",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2881",
  "quartz-webpack": "static-1.2828",
  "ai-components-ui-library": "static-1.8131",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4549",
  "foundations-theming": "static-1.4122",
  "quartz-auth": "static-1.279",
  "usage-tracker-session-replay": "static-1.4738",
  "foundations-theming-base": "static-1.3107",
  "HeadJS": "static-2.696",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2811",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4048",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7641",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3385",
  "persist-promise": "static-1.3404",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9144",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9259",
  "hubspotter-http": "static-1.4404",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6968",
  "crm-message-bus": "static-1.42136",
  "customer-data-filters-ui-msw-helpers": "static-1.21025",
  "customer-data-objects-ui-components": "static-1.12719",
  "customer-data-reference-ui-components": "static-1.12856",
  "customer-data-ui-utilities": "static-1.9543",
  "framework-builder-read-service-client": "static-1.3772",
  "framework-data-schema-quick-fetch": "static-1.6491",
  "framework-data-schema-resolvers": "static-1.6586",
  "inbound-db-properties-service-client": "static-1.3604",
  "multi-account-reference-resolvers": "static-1.684",
  "onboarding-tours": "static-1.16157",
  "reporting-datasets-permissions-lib": "static-1.12787",
  "ui-addon-teams": "static-1.21110",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67382",
  "customer-data-properties": "static-1.50534",
  "forms-ai-lib": "static-1.3866",
  "forms-utils-lib": "static-1.12011",
  "foundations-components-test-utils": "static-1.4830",
  "react-dnd-compat": "static-1.4341",
  "react-tinymce": "static-1.54408",
  "tinymce-config": "static-2.53534",
  "ui-gdpr-components": "static-1.10063",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3616",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1003",
  "ui-fonts": "static-1.403",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.777",
  "mobile-manifest-mixins": "static-1.469",
  "quartz-head": "static-1.269",
  "quartz-i18n": "static-1.279",
  "quartz-routing": "static-1.34",
  "quartz-test": "static-1.279",
  "batch-promise": "static-1.1247",
  "external-options-client-types": "static-1.3908",
  "react-colorpicker": "static-2.9930",
  "copilot-toolkit": "static-1.10324",
  "data-quality-ui-library": "static-1.12132",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40461",
  "reporting-insights-lib": "static-1.926",
  "reporting-plugins": "static-1.9879",
  "ui-addon-draggable-compat": "static-2.3971",
  "ui-addon-opt": "static-4.8106",
  "ui-shepherd-react": "static-3.9861",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24495",
  "hubspot-apollo-client": "static-1.4597",
  "sales-templates-service-types-lib": "static-1.3918",
  "ui-business-units-lib": "static-1.8739",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5352",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3829",
  "upgrade-management-service-types": "static-1.4225",
  "timezone-utils": "static-2.4961",
  "bender-build-tools": "static-1.2832",
  "chatspot-core": "static-1.20023",
  "chirp-fetch": "static-1.1599",
  "bend-plugin-foundations-theming": "static-1.2605",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9257",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3548",
  "crm-pipelines-api-client-types": "static-1.3890",
  "multi-currency-client-types": "static-1.3444",
  "getting-started-shared-tasks": "static-1.17655",
  "growth-data-modal": "static-1.5050",
  "growth-onboarding-confetti": "static-1.2768",
  "growth-onboarding-next-action-utils": "static-1.1211",
  "navigation-components": "static-1.17029",
  "onboarding-tours-client": "static-1.4371",
  "onboarding-tours-utils": "static-1.223",
  "ui-shepherd-tracker": "static-1.7242",
  "ui-universal-auth": "static-1.8584",
  "user-context": "static-1.4812",
  "cms-field-types": "static-1.4524",
  "content-icons-ui": "static-1.2126",
  "integrations-lib": "static-1.15155",
  "calling-global-api": "static-1.63394",
  "calling-internal-common": "static-1.31006",
  "calling-lifecycle-internal": "static-1.64776",
  "calling-lifecycle-messages": "static-1.57070",
  "commerce-products-lib": "static-1.8599",
  "crm-links": "static-1.5969",
  "file-manager-components": "static-1.22652",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.377",
  "inbounddb-objects-service-types": "static-1.3975",
  "meetings-icalendar-utils-lib": "static-1.351",
  "object-builder-ui-client": "static-1.47712",
  "pipeline-validation-client-types": "static-1.3712",
  "property-value-citations": "static-1.1148",
  "pulse": "static-1.211",
  "smart-property-lib": "static-1.5610",
  "tiered-pricing": "static-1.692",
  "ui-addon-iframeable": "static-1.8738",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19318",
  "tinymce-themes": "static-1.55504",
  "data-token-picker": "static-1.15915",
  "hub-http-contrib": "static-1.2762",
  "interframe": "static-3.4509",
  "tinymce-data": "static-1.39619",
  "tinymce-plugins": "static-1.56648",
  "ui-addon-sales-email": "static-1.4931",
  "magpie-lib": "static-1.5292",
  "magpie-types": "static-1.4752",
  "simple-logging-lib": "static-1.2768",
  "content-assistance-lib": "static-1.7327",
  "dashboard-lib": "static-1.80302",
  "ExportDialog": "static-6.10106",
  "hubspot-prosemirror": "static-1.17375",
  "hubspot-prosemirror-plugins": "static-1.17367",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8406",
  "campaign-roi-lib": "static-1.8035",
  "feedback-loader": "static-1.28706",
  "commerce-analytics-service-client": "static-1.3406",
  "onboarding-scopes": "static-1.6160",
  "apollo-link-hub-http": "static-2.4366",
  "hubspot-apollo-cache": "static-1.56",
  "growth-monetization-service-types": "static-1.4241",
  "nav-client-types": "static-1.2049",
  "purchase-motions-api": "static-1.5355",
  "trials-service-types": "static-1.3642",
  "chatspot-client-types": "static-1.10371",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.443",
  "getting-started-shared-tasks-store": "static-1.16773",
  "integrations-error-boundary-lib": "static-1.12570",
  "integrations-tracking-lib": "static-1.5301",
  "native-integrations-shared-strings": "static-1.7505",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10090",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31012",
  "shared-worker-versioning": "static-1.10734",
  "calling-usage-tracker": "static-1.6256",
  "calling-orchestration-shared-library": "static-1.34551",
  "customer-data-tracking": "static-1.6579",
  "products-iframe-lib": "static-1.7114",
  "products-ui-components-shared-msw-handlers": "static-1.9641",
  "location-customization-utils-lib": "static-1.8302",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3873",
  "video-components-external": "static-1.10312",
  "video-data-lib": "static-1.33970",
  "directed-graph": "static-1.654",
  "event-emitter": "static-1.642",
  "breeze-intelligence-kit": "static-1.5197",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9342",
  "fsm": "static-1.3448",
  "policy-lib": "static-1.6518",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9405",
  "navigation-messaging": "static-1.6356",
  "FileManagerLib": "static-1.38292",
  "NamespacedHubStyle": "static-2.8822",
  "FileManagerCore": "static-1.38151",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11888",
  "layout-dnd-utils": "static-1.10863",
  "react-codemirror": "static-1.10322",
  "ui-addon-emoji-picker": "static-1.9607",
  "ui-brand-identity-lib": "static-1.13484",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27726",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8283",
  "payment-link-components": "static-1.22709",
  "EmailSignatureEditor": "static-1.23779",
  "eligibility-engine-service-types": "static-1.2923",
  "universal-page-editor-lib": "static-1.2713",
  "calling-orchestration-schema": "static-1.34776",
  "sales-views-client-types": "static-1.4010",
  "crm-record-cards-service-types": "static-1.3376",
  "content-media-composition-data-lib": "static-1.11126",
  "content-media-compositions": "static-2.15133",
  "media-bridge-lib": "static-1.18437",
  "trellis-story-utils": "static-1.4239",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5491",
  "FileManagerImages": "static-1.35803",
  "video-components": "static-1.12315",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4251",
  "video-embed": "static-1.34804",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67457",
  "layout-data-lib": "static-1.9188",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6303",
  "commerce-tours-lib": "static-1.5585",
  "growth-onboarding-reliability": "static-1.4805",
  "sales-checkout-service-client": "static-1.3418",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21155",
  "sales-email-signature-service-client": "static-1.3559",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3929",
  "advanced-menus-core": "static-1.14679",
  "advanced-menus-lib": "static-1.11668",
  "ui-memberships-settings-lib": "static-1.33213",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14678",
  "simple-menus-lib": "static-1.16195"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33781",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33786",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1838",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5308",
  "hs-test-utils": "/hs-test-utils/static-1.7700",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11141",
  "I18n": "/I18n/static-7.1548",
  "jasmine-immutable": "/jasmine-immutable/static-1.2735",
  "jasmine-runner": "/jasmine-runner/static-1.6173",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6604",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16351",
  "reporting-data": "/reporting-data/static-1.66177",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8110",
  "reporting-visualizations": "/reporting-visualizations/static-1.58253",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4461",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4789",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2183",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.707",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38591",
  "customer-data-objects": "/customer-data-objects/static-1.7332",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7786",
  "data-fetching-client": "/data-fetching-client/static-1.9393",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4251",
  "flux-actions": "/flux-actions/static-1.299",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85069",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4448",
  "foundations-components": "/foundations-components/static-1.7347",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11449",
  "icons": "/icons/static-2.615",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6861",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3577",
  "property-translator": "/property-translator/static-1.5131",
  "quartz-config": "/quartz-config/static-1.382",
  "quartz-core": "/quartz-core/static-1.5823",
  "quick-fetch": "/quick-fetch/static-1.3653",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5101",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7879",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7806",
  "report-customization-components": "/report-customization-components/static-1.12268",
  "reporting-enablement": "/reporting-enablement/static-1.21805",
  "reporting-reports": "/reporting-reports/static-1.65855",
  "reporting-snowflake": "/reporting-snowflake/static-1.54795",
  "reporting-ui-components": "/reporting-ui-components/static-2.63449",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4324",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8651",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8765",
  "sanitize": "/sanitize/static-1.4192",
  "sanitize-text": "/sanitize-text/static-1.7857",
  "self-service-api": "/self-service-api/static-1.9944",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1464",
  "signup-constants": "/signup-constants/static-1.18235",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20245",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7750",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4490",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10713",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10845",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9264",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17444",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10582",
  "ui-images": "/ui-images/static-2.1068",
  "UIComponents": "/UIComponents/static-3.8088",
  "usage-tracker": "/usage-tracker/static-1.7052",
  "usage-tracker-container": "/usage-tracker-container/static-1.7042",
  "usage-tracker-core": "/usage-tracker-core/static-1.6902",
  "usage-tracker-public": "/usage-tracker-public/static-1.6863",
  "viral-links-lib": "/viral-links-lib/static-1.6739",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3153",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2881",
  "quartz-webpack": "/quartz-webpack/static-1.2828",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8131",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4549",
  "foundations-theming": "/foundations-theming/static-1.4122",
  "quartz-auth": "/quartz-auth/static-1.279",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4738",
  "foundations-theming-base": "/foundations-theming-base/static-1.3107",
  "HeadJS": "/HeadJS/static-2.696",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2811",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4048",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7641",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3385",
  "persist-promise": "/persist-promise/static-1.3404",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9144",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9259",
  "hubspotter-http": "/hubspotter-http/static-1.4404",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6968",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21025",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12719",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12856",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9543",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3772",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6491",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6586",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3604",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.684",
  "onboarding-tours": "/onboarding-tours/static-1.16157",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12787",
  "ui-addon-teams": "/ui-addon-teams/static-1.21110",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67382",
  "customer-data-properties": "/customer-data-properties/static-1.50534",
  "forms-ai-lib": "/forms-ai-lib/static-1.3866",
  "forms-utils-lib": "/forms-utils-lib/static-1.12011",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4830",
  "react-dnd-compat": "/react-dnd-compat/static-1.4341",
  "react-tinymce": "/react-tinymce/static-1.54408",
  "tinymce-config": "/tinymce-config/static-2.53534",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10063",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3616",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1003",
  "ui-fonts": "/ui-fonts/static-1.403",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.777",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
  "quartz-head": "/quartz-head/static-1.269",
  "quartz-i18n": "/quartz-i18n/static-1.279",
  "quartz-routing": "/quartz-routing/static-1.34",
  "quartz-test": "/quartz-test/static-1.279",
  "batch-promise": "/batch-promise/static-1.1247",
  "external-options-client-types": "/external-options-client-types/static-1.3908",
  "react-colorpicker": "/react-colorpicker/static-2.9930",
  "copilot-toolkit": "/copilot-toolkit/static-1.10324",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12132",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40461",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.926",
  "reporting-plugins": "/reporting-plugins/static-1.9879",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3971",
  "ui-addon-opt": "/ui-addon-opt/static-4.8106",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9861",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24495",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4597",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3918",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8739",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5352",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3829",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4225",
  "timezone-utils": "/timezone-utils/static-2.4961",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "chatspot-core": "/chatspot-core/static-1.20023",
  "chirp-fetch": "/chirp-fetch/static-1.1599",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2605",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9257",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3548",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3890",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3444",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17655",
  "growth-data-modal": "/growth-data-modal/static-1.5050",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2768",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1211",
  "navigation-components": "/navigation-components/static-1.17029",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4371",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.223",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7242",
  "ui-universal-auth": "/ui-universal-auth/static-1.8584",
  "user-context": "/user-context/static-1.4812",
  "cms-field-types": "/cms-field-types/static-1.4524",
  "content-icons-ui": "/content-icons-ui/static-1.2126",
  "integrations-lib": "/integrations-lib/static-1.15155",
  "calling-global-api": "/calling-global-api/static-1.63394",
  "calling-internal-common": "/calling-internal-common/static-1.31006",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64776",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57070",
  "commerce-products-lib": "/commerce-products-lib/static-1.8599",
  "crm-links": "/crm-links/static-1.5969",
  "file-manager-components": "/file-manager-components/static-1.22652",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.377",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3975",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.351",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47712",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3712",
  "property-value-citations": "/property-value-citations/static-1.1148",
  "pulse": "/pulse/static-1.211",
  "smart-property-lib": "/smart-property-lib/static-1.5610",
  "tiered-pricing": "/tiered-pricing/static-1.692",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8738",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19318",
  "tinymce-themes": "/tinymce-themes/static-1.55504",
  "data-token-picker": "/data-token-picker/static-1.15915",
  "hub-http-contrib": "/hub-http-contrib/static-1.2762",
  "interframe": "/interframe/static-3.4509",
  "tinymce-data": "/tinymce-data/static-1.39619",
  "tinymce-plugins": "/tinymce-plugins/static-1.56648",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4931",
  "magpie-lib": "/magpie-lib/static-1.5292",
  "magpie-types": "/magpie-types/static-1.4752",
  "simple-logging-lib": "/simple-logging-lib/static-1.2768",
  "content-assistance-lib": "/content-assistance-lib/static-1.7327",
  "dashboard-lib": "/dashboard-lib/static-1.80302",
  "ExportDialog": "/ExportDialog/static-6.10106",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17375",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17367",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8406",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8035",
  "feedback-loader": "/feedback-loader/static-1.28706",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3406",
  "onboarding-scopes": "/onboarding-scopes/static-1.6160",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4366",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.56",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4241",
  "nav-client-types": "/nav-client-types/static-1.2049",
  "purchase-motions-api": "/purchase-motions-api/static-1.5355",
  "trials-service-types": "/trials-service-types/static-1.3642",
  "chatspot-client-types": "/chatspot-client-types/static-1.10371",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.443",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16773",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12570",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5301",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7505",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10090",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31012",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10734",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6256",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34551",
  "customer-data-tracking": "/customer-data-tracking/static-1.6579",
  "products-iframe-lib": "/products-iframe-lib/static-1.7114",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9641",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8302",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3873",
  "video-components-external": "/video-components-external/static-1.10312",
  "video-data-lib": "/video-data-lib/static-1.33970",
  "directed-graph": "/directed-graph/static-1.654",
  "event-emitter": "/event-emitter/static-1.642",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5197",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9342",
  "fsm": "/fsm/static-1.3448",
  "policy-lib": "/policy-lib/static-1.6518",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9405",
  "navigation-messaging": "/navigation-messaging/static-1.6356",
  "FileManagerLib": "/FileManagerLib/static-1.38292",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8822",
  "FileManagerCore": "/FileManagerCore/static-1.38151",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11888",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10863",
  "react-codemirror": "/react-codemirror/static-1.10322",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9607",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13484",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27726",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8283",
  "payment-link-components": "/payment-link-components/static-1.22709",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23779",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2923",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2713",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34776",
  "sales-views-client-types": "/sales-views-client-types/static-1.4010",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3376",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11126",
  "content-media-compositions": "/content-media-compositions/static-2.15133",
  "media-bridge-lib": "/media-bridge-lib/static-1.18437",
  "trellis-story-utils": "/trellis-story-utils/static-1.4239",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5491",
  "FileManagerImages": "/FileManagerImages/static-1.35803",
  "video-components": "/video-components/static-1.12315",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4251",
  "video-embed": "/video-embed/static-1.34804",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67457",
  "layout-data-lib": "/layout-data-lib/static-1.9188",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6303",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5585",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4805",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3418",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21155",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3559",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3929",
  "advanced-menus-core": "/advanced-menus-core/static-1.14679",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11668",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33213",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14678",
  "simple-menus-lib": "/simple-menus-lib/static-1.16195"
}
};
